/**
 * A sentinel value to signal the Default Registry (crates-io)
 */
export const DEFAULT_REGISTRY_URL = Symbol('DEFAULT_REGISTRY_URL');
